import { render, staticRenderFns } from "./StudentApplicationStatusComp.vue?vue&type=template&id=8f743e5a&"
import script from "./StudentApplicationStatusComp.vue?vue&type=script&lang=ts&"
export * from "./StudentApplicationStatusComp.vue?vue&type=script&lang=ts&"
import style0 from "./StudentApplicationStatusComp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports